import { render } from "./create-retail.vue?vue&type=template&id=4ecb102c&scoped=true&ts=true"
import script from "./create-retail.vue?vue&type=script&lang=ts"
export * from "./create-retail.vue?vue&type=script&lang=ts"

import "./create-retail.vue?vue&type=style&index=0&id=4ecb102c&scoped=true&lang=css"
import "./create-retail.vue?vue&type=style&index=1&id=4ecb102c&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ecb102c"]])

export default __exports__